'use client';

import { type Component, type ComponentProps } from '../../types/component';
import {
  ChipBase,
  type ChipBaseWithAvatar,
  type ChipBaseWithIcon,
} from './internal/ChipBase';

type ToggleChipBaseProps = ChipBaseWithIcon | ChipBaseWithAvatar;

type ToggleChipProps = ComponentProps<
  ToggleChipBaseProps,
  'button',
  'disabled'
>;

type ToggleChipComponent = Component<ToggleChipBaseProps, 'button', 'disabled'>;

const ToggleChip: ToggleChipComponent = (props) => {
  const {
    children,
    icon,
    avatar,
    size,
    isDisabled,
    isFullWidth,
    elevation,
    isSelected = false,
    ...rest
  } = props;

  const leadingProps =
    icon != null ? { icon } : avatar != null ? { avatar } : {};

  return (
    <ChipBase
      {...rest}
      {...leadingProps}
      size={size}
      isDisabled={isDisabled}
      isFullWidth={isFullWidth}
      elevation={elevation}
      isSelected={isSelected}
      aria-pressed={isSelected}
    >
      {children}
    </ChipBase>
  );
};

ToggleChip.displayName = 'ToggleChip';

export { ToggleChip, type ToggleChipProps, type ToggleChipBaseProps };
